
<template>
  <div class="my-collection">
    <ul class="collection-list">
      <li v-for="(item, index) in list" :key="index">
        <pi-station-item
          :item="item"
          @change="collected"
          :index="index"
        ></pi-station-item>
      </li>
    </ul>
    <pi-no-list-data :list="list" text="您还没有收藏哦">
      <img
        src="../../picture/no-data-icon/collection.png"
        class="no-list-icon"
      />
    </pi-no-list-data>
  </div>
</template>

<script>
import stationItem from "@/components/pi-station-item/pi-station-item";
import noListData from "@/components/pi-no-list-data/pi-no-list-data.vue";
import { getCollect } from "../../common/api";
import { forStationList } from "@/common/common-data";
export default {
  name: "my-collection",
  data() {
    return {
      list: [],
      userLat: null,
      userLng: null,
    };
  },
  mounted() {
    let staParam = this.$common.get("staParam");
    if (staParam) {
      this.userLat = staParam.userLat;
      this.userLng = staParam.userLng;
    }
    this.getList();
  },

  components: {
    [stationItem.name]: stationItem,
    [noListData.name]: noListData,
  },
  methods: {
    async getList() {
      let ret = await getCollect(
        { userLat: this.userLat, userLng: this.userLng },
        true
      );

      if (ret.status === this.$config.ajaxStatus) {
        this.list = forStationList(ret.data);
      }
    },
    /**
     * 收藏点击，组件里已经请求成功
     * @param {*} e
     */
    collected(item) {
      let index = item.index;
      this.list[index] = item;
    },
  },
};
</script>

<style lang="less" scoped>
.my-collection {
  background: #f7f7f7;
  height: 100%;
  .collection-list {
    padding: 0.2rem 0.2rem;
    li {
      margin-top: 0.2rem;
      background: white;
    }
    li:first-child {
      margin-top: 0;
    }
  }
}
</style>
